export function SignalGlyph() {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="currentColor"
      aria-hidden
    >
      <rect x="0" y="8" width="3" height="4" rx="1" />
      <rect x="5" y="5.5" width="3" height="6.5" rx="1" />
      <rect x="10" y="3" width="3" height="9" rx="1" />
      <rect x="15" y="0" width="3" height="12" rx="1" />
    </svg>
  );
}

export function WifiGlyph() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="currentColor"
      aria-hidden
    >
      <path d="M8 9.6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM8 5.8c1.6 0 3 .6 4.1 1.7l-1.4 1.4A3.8 3.8 0 0 0 8 7.8c-1 0-2 .4-2.7 1.1L3.9 7.5A5.8 5.8 0 0 1 8 5.8zM8 2c2.6 0 5 1 6.8 2.8l-1.4 1.4A7.6 7.6 0 0 0 8 4a7.6 7.6 0 0 0-5.4 2.2L1.2 4.8A9.6 9.6 0 0 1 8 2z" />
    </svg>
  );
}

export function BatteryGlyph() {
  return (
    <svg width="27" height="13" viewBox="0 0 27 13" aria-hidden>
      <rect
        x=".5"
        y=".5"
        width="23"
        height="12"
        rx="3.5"
        fill="none"
        stroke="currentColor"
        strokeOpacity=".4"
      />
      <rect x="2" y="2" width="20" height="9" rx="2" fill="currentColor" />
      <path d="M25 4.5v4a2 2 0 0 0 0-4z" fill="currentColor" fillOpacity=".4" />
    </svg>
  );
}

export function ChevronLeftGlyph() {
  return (
    <svg
      width="13"
      height="22"
      viewBox="0 0 13 22"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M11 2 2 11l9 9" />
    </svg>
  );
}

export function ChevronRightGlyph() {
  return (
    <svg
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      aria-hidden
    >
      <path d="M1.5 1.5 5.5 5.5l-4 4" />
    </svg>
  );
}

export function VideoGlyph() {
  return (
    <svg
      width="26"
      height="18"
      viewBox="0 0 26 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
    >
      <rect x="1" y="1.5" width="16" height="15" rx="3.5" />
      <path d="M17 7l7-4v12l-7-4z" strokeLinejoin="round" />
    </svg>
  );
}

export function PersonGlyph({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <circle cx="12" cy="8" r="4.2" />
      <path d="M4 20.5c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5z" />
    </svg>
  );
}

export function PlusGlyph() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden
    >
      <path d="M9 2v14M2 9h14" />
    </svg>
  );
}

export function MicGlyph() {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="currentColor"
      aria-hidden
    >
      <rect x="3" y="0" width="6" height="11" rx="3" />
      <path d="M1.5 8a4.5 4.5 0 0 0 9 0H12a6 6 0 0 1-5.25 5.95V17h-1.5v-3.05A6 6 0 0 1 0 8z" />
    </svg>
  );
}

export function FlashlightGlyph() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M8 2h8v3l-2 4v13h-4V9L8 5z" />
    </svg>
  );
}

export function CameraGlyph() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M4 7h3.2l1.6-2h6.4l1.6 2H20a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm8 2.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
    </svg>
  );
}

export function MessagesBadgeGlyph() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 3C6.5 3 2 6.6 2 11c0 2.4 1.3 4.5 3.4 6L4.5 21l4.2-2.1c1 .3 2.1.4 3.3.4 5.5 0 10-3.6 10-8.1S17.5 3 12 3z" />
    </svg>
  );
}
